import { EmailClass } from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const tableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLW140002_01,
  },
  {
    title: "メール種別",
    keyword: "emailClass",
    type: "selectForm",
    selectPropsList: TkGetCodeList(EmailClass),
    disabled: true,
  },

  {
    title: "テンプレート名",
    keyword: "tempName",
    requiredIcon: true,
    inputProps: { maxLength: 85 },
  },
  {
    title: "タイトル",
    keyword: "title",
    requiredIcon: true,
    inputProps: { maxLength: 85 },
  },
  {
    title: "本文",
    keyword: "text",
    type: "textarea",
    requiredIcon: true,
    inputProps: { maxLength: 1000 },
  },
];

const schema = {
  tempName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },

  title: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  text: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 1000,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "1000"),
    },
  },
};

export { tableList, schema };
